import axios from "axios";

class AddressService {
  public getByZipCode = async (zipcode: string) => {
    return axios.get(`https://viacep.com.br/ws/${zipcode}/json`);
  }

  public getDistrictsByUF = async (uf: string) => {
    return axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/distritos`);
  }

  public getUfs = async () => {
    return axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados`);
  }
}

export default new AddressService();
